export default __webpack_public_path__ + "static/ForgetSectionLeft_uk-cb55edeeb7499aef3aed32b4d06553b8.png";